import './radiobutton.scss';
import './radiobutton';

require('../label');
